
		<h2 class="title">Editar Provider</h2>
		<app-cosechador-update *ngIf= " selected == 'Cosechador'">
		</app-cosechador-update>
		<app-vendedor-update *ngIf= " selected == 'Vendedor'">
		</app-vendedor-update>
	